import React, { useEffect, useRef } from "react"
import AniLink from "gatsby-plugin-transition-link/AniLink"
import styled from "styled-components"
import { AnchorLink } from "gatsby-plugin-anchor-links"
import PropTypes from "prop-types"
import logo from "../../images/logo/logo-full.svg"
import { StyledButton } from "../Button"

const StyledNav = styled.nav`
  position: fixed;
  top: 0;
  left: 0;
  height: auto;
  z-index: 1000;
  width: calc(100vw - 32px);
  background-color: transparent;
  padding: 16px;
  transition: padding 0.2s ease;
  @media (min-width: 992px) {
    padding: 60px 32px;
    width: calc(100vw - 60px);
    &.fixed-bg {
      background-color: #000;
      height: auto;
      padding: 24px 32px;
      border-bottom: 1px solid #333;
    }
  }
  .container {
    max-width: 1200px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 1fr auto auto auto auto auto;
  }
  &.fixed-bg {
    background-color: #000;
    height: auto;
  }
`

const StyledNavButton = styled(StyledButton)`
  width: 100%;
  padding: 10px !important;
  font-size: 13px;
  letter-spacing: 2px;
  display: none;
  font-family: "Made Bold", sans-serif;
  text-decoration: none;
  @media (min-width: 992px) {
    width: auto;
    display: block;
  }
`

const StyledLink = styled(AniLink)`
  color: #eae8dd;
  font-family: "Made Bold";
  font-size: 13px;
  letter-spacing: 2px;
  padding: 8px;
  margin-bottom: 0;
  margin-right: 60px;
  text-transform: uppercase;
  text-decoration: none;
  display: none;
  transition: 0.2s ease;
  &.menu {
    position: relative;
    display: block;
    margin-right: 0;
    @media (min-width: 992px) {
      display: none;
    }
  }
  &:hover {
    transform: scale(1.1);
  }
  @media (min-width: 992px) {
    display: block;
  }
`

const Navigation = ({ blackNav }) => {
  const refNav = useRef(null)

  const listenToScroll = () => {
    const position = window.pageYOffset
    if (position > 50) {
      refNav.current.classList.add("fixed-bg")
    } else {
      refNav.current.classList.remove("fixed-bg")
    }
  }

  useEffect(() => {
    listenToScroll()
    window.addEventListener("scroll", listenToScroll)
    return () => window.removeEventListener("scroll", listenToScroll)
  })

  return (
    <StyledNav ref={refNav} style={{ backgroundColor: blackNav && "#000" }}>
      <div className="container">
        <AniLink cover to="/" bg="#474dc4">
          <img src={logo} alt="logo" title="Nis Media" />
        </AniLink>
        <StyledLink
          paintDrip
          to="/mobile-nav/"
          hex="#474dc4"
          duration={0.9}
          className="menu"
        >
          MENU
        </StyledLink>
        <StyledLink bg="#474dc4" cover to="/o-nas/" duration={0.9}>
          O nas
        </StyledLink>
        <StyledLink as={AnchorLink} to="/#oferta">
          Oferta
        </StyledLink>
        <StyledLink cover to="/blog/" bg="#474dc4" duration={0.9}>
          Blog
        </StyledLink>
        <StyledLink as={AnchorLink} to="/#realizacje">
          Realizacje
        </StyledLink>
        <StyledNavButton as={AnchorLink} to="/#kontakt">
          ZATRUDNIJ NAS
        </StyledNavButton>
      </div>
    </StyledNav>
  )
}

export default Navigation

Navigation.propTypes = {
  blackNav: PropTypes.bool,
}

Navigation.defaultProps = {
  blackNav: false,
}
